/**
 * Entity
 *
 * @group ISOBMFF
 *
 * @beta
 */
export type Entity = {
	/** Entity ID */
	entityId: number;
};
